<template>
  <div class="standing">
    <div class="lading_conter_search" id="lading_conter_search-billQuery">
      <my-search-query ref="queryList" :fromList="fromList" :isShow="true" @queryEven="getTableParams" />
    </div>
    <div class="lading_conter">
      <div class="lading_table">
        <div class="lading_conter_table">
          <sp-table
            ref="spTable"
            :parentTableData.sync="tableData"
            :parentCol.sync="tableDataCol"
            :row-class-name="tableRowClassName"
            :dragDrop="true"
            height="100%">
            <el-table-column align="center" type="selection" class="selection"></el-table-column>
            <el-table-column align="center" type="index" width="50" label="序号" class-name="index"></el-table-column>
            <sp-table-column :align="item.titleAlignment" v-for="(item, index) in tableDataCol" :key="index" :width="item.displayWidth"
                             :prop="tableDataCol[index].fieldName">
              <template slot="header">
                <p>{{item.fieldAlias}}</p>
              </template>
              <template v-slot="{ scope }">
                <div class="span" :style="{color: initColor(scope.row), textAlign: item.alignment}">
                  {{scope.row[tableDataCol[index].fieldName]}}
                </div>
              </template>
            </sp-table-column>
          </sp-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { spTable, spTableColumn } from '@/components/sptable';
import mySearchQuery from '../comm/searchQuery';
import dayjs from 'dayjs';

const _ = require('lodash');

export default {
  name: 'adminBillQuery',
  components: {
    spTable,
    spTableColumn,
    mySearchQuery,
  },
  data() {
    return {
      tableData: [],
      heightSearch: 0,
      bargain: [],
      getOutCarTankList: [],
      getTGuestNumList: [],
      getRefGoodsList: [],
      formInline: {},
      tableDataCol: []
    };
  },
  computed: {
    ...mapGetters({
      userInfor: 'user/userInfor',
      adminAccountBooksAction: 'dictionary/adminAccountBooksAction',
    }),
    fromList() {
      let arr = [
        // { label: '罐号', key: 'tankId', type: 'input', showDialog: true, tips: '...', dialog: 'showgetTankId', code: 3003, colSpan:8 },
        // { label: '产品', key: 'goodsName', type: 'input', showDialog: true, tips: '...', dialog: 'showGoodsIDBillQuery', code: 4002,colSpan:8 },
        {
          label: '合同号',
          key: 'bargainId',
          valData: this.bargain,
          type: 'select',
          tips: '...',
          dialog: 'showmainOrderGetTGuest',
          labelVal: 'BargainID',
          multiple: false,
          value: 'BargainID',
          code: 7000,
          colSpan: 8
        },
        {
          label: '罐号',
          key: 'tankId',
          type: 'select',
          showDialog: true,
          tips: '...',
          dialog: 'showGoodsID',
          valData: this.getOutCarTankList,
          labelVal: 'TankID',
          value: 'TankID',
          multiple: false,
          colSpan: 8
        },
        {
          label: '产品',
          key: 'goodsId',
          type: 'select',
          showDialog: true,
          tips: '...',
          dialog: 'showGoodsID',
          valData: this.getRefGoodsList,
          labelVal: 'Name',
          value: 'GoodsID',
          multiple: false,
          colSpan: 8
        },
        {
          label: '提货人',
          key: 'tGuestId',
          valData: this.getTGuestNumList,
          type: 'select',
          tips: '...',
          dialog: 'showgetTGuest2',
          labelVal: 'Name',
          value: 'GuestID',
          code: 4000,
          colSpan: 8
        },
        { label: '开始时间', key: 'beginDate', type: 'timeSelect', default: `${this.$utils.getTimeByDay(new Date(),0,true)} 00:00:01`, colSpan:8},
        { label: '结束时间', key: 'endDate', type: 'timeSelect', default: `${this.$utils.getTimeByDay(new Date())} 23:59:59`,colSpan:8 },
      ];
      return arr;
    },
  },
  created() {
    this.getBargainEven();
    this.getOutCarTankAPI();
    this.getRefGoodsAPI();
    this.getOutCarTankAPI();
    this.getTGuestNum();
    this.getAdminAccountBooksAction();
  },
  async mounted() {
    this.getTableParams(false);
  },
  methods: {
    // 合同号弹出选择
    getBargainEven() {
      this.$services.post({
        type: 'GUESTBUSINESS',
        url: 'getBargain',
        params: {
          accountId: this.userInfor.accountId,
        },
      }).then(res => {
        this.bargain = res.bean;
      });
    },
    initColor(row) {
      let color = '';
      if (row.TypeName === '期初') {
        color = 'rgb(240, 84, 89)';
      }
      return color;
    },
    tableRowClassName({row, rowIndex}) {
        console.log(row)
        if(row.TankID === '总计') {
          return 'sum'
        }
        if(row.TankID === '小计') {
          return 'subtotal'
        }
        if(row.TankID === '累计') {
          return 'accumulative'
        }

        return ''
    },
    ...mapActions({
      getAdminAccountBooksAction: 'dictionary/getAdminAccountBooksAction',
    }),
    licenseNumberSelectionChange() {

    },
    listAccountBooksAPI(params) {
      this.$services.postLoading({
        type: 'GUESTBUSINESS',
        url: 'listAccountBooks',
        params,
      }).then(res => {
        this.tableData = res.bean;
        this.$nextTick(() => {
          this.$refs.spTable.initTable();
        });
      });
    },
    // 台帐参数处理
    getTableParams(start) {
      let params = {
        accountId: this.userInfor.accountId,
        sortByDate: 1,
      };
      if (!start) {
        let fromData = _.cloneDeep(this.$refs.queryList.fromData);
        if (fromData.TankID) {
          fromData.tankId = fromData.TankID;
          delete fromData.TankID;
        }
        for (let i in fromData) {
          if (!fromData[i] || typeof fromData[i] === 'object') {
            delete fromData[i];
          }
        }
        Object.assign(params, fromData);
      }
      delete params.Name;
      delete params.goodsName;
      this.listAccountBooksAPI(params);
    },
    // 产品弹出选择
    getRefGoodsAPI() {
      let params = {
        accountId: this.userInfor.accountId,
        // bargainId: this.formInline.BargainID,
        // goodsId: this.formInline.GoodsID
      };
      this.$services.postLoading({
        type: 'GUESTBUSINESS',
        url: 'getRefGoods',
        params
      }).then(res => {
        this.getRefGoodsList = res.bean;
      });
    },
    // 提货人编号
    getTGuestNum() {
      let params = {
        accountId: this.userInfor.accountId
      };
      this.$services.postLoading({
        type: 'GUESTBUSINESS',
        url: 'getTGuest',
        params
      }).then(res => {
        this.getTGuestNumList = res.bean;
      });
    },
    // 罐号选择
    getOutCarTankAPI() {
      this.$services.postLoading({
        type: 'GUESTBUSINESS',
        url: 'getTank',
        params: {
          accountId: this.userInfor.accountId
        }
      }).then(res => {
        this.getOutCarTankList = res.bean;
      });
    },
    addColData(callback) {
      this.licenseNumberList.push(JSON.parse(JSON.stringify(
        Object.assign(this.licenseNumberOriginData, {
          uid: this.$utils.getUid(),
          id: this.licenseNumberList.length + 1
        })
      )));
      this.$nextTick(() => {
        if (typeof callback === 'function') callback();
      });
    },
    initCol() {
      this.adminAccountBooksAction.length > 0
      && (this.tableDataCol = this.adminAccountBooksAction.map(itme => {
          let info = itme;
          info.field = itme.fieldName;
          info.title = itme.fieldAlias;
          info.width = itme.displayWidth;
          return info;
        })
      );
    },
  },
  watch: {
    adminAccountBooksAction() {
      this.initCol();
    },
    tableDataCol(val) {
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
  }
};
</script>
<style lang="scss">
  .standing {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
</style>
